/**
 * Navigation items the user may see. `admin_only` and `required_role` hide an item
 * (and everything under it) for users without that role; a group that ends up
 * without items is dropped. Groups may be nested (`submenu` within `submenu`).
 *
 * @param {Array<Object>} items - navigation items, each optionally with `submenu`
 * @param {string[]} roles - the current user's role names
 * @returns {Array<Object>} a filtered copy; the input is not changed
 */
export function filterNavigation(items, roles = []) {
  const allowed = (item) =>
    (!item.admin_only || roles.includes("admin")) &&
    (!item.required_role || roles.includes(item.required_role));

  return items
    .filter(allowed)
    .map((item) =>
      item.submenu
        ? { ...item, submenu: filterNavigation(item.submenu, roles) }
        : item,
    )
    .filter((item) => !item.submenu || item.submenu.length > 0);
}
